@file:OptIn(InternalResourceApi::class)

package com.hyperether.goodjob.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.hyperether.goodjob.resources/"

public val Res.string.about: StringResource by lazy {
      StringResource("string:about", "about", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 188, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168, 21),
      ))
    }

public val Res.string.about_contact: StringResource by lazy {
      StringResource("string:about_contact", "about_contact", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 41),
      ))
    }

public val Res.string.about_job: StringResource by lazy {
      StringResource("string:about_job", "about_job", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 52, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52, 29),
      ))
    }

public val Res.string.about_site: StringResource by lazy {
      StringResource("string:about_site", "about_site", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 90, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82, 34),
      ))
    }

public val Res.string.about_this_contact: StringResource by lazy {
      StringResource("string:about_this_contact", "about_this_contact", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 133, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117, 50),
      ))
    }

public val Res.string.access_dashboard: StringResource by lazy {
      StringResource("string:access_dashboard", "access_dashboard", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 210, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190, 48),
      ))
    }

public val Res.string.access_the_platform: StringResource by lazy {
      StringResource("string:access_the_platform", "access_the_platform", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 263, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239, 171),
      ))
    }

public val Res.string.active: StringResource by lazy {
      StringResource("string:active", "active", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 467, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 411, 22),
      ))
    }

public val Res.string.add: StringResource by lazy {
      StringResource("string:add", "add", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2618, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2070, 15),
      ))
    }

public val Res.string.add_a_contact: StringResource by lazy {
      StringResource("string:add_a_contact", "add_a_contact", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 490, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 434, 113),
      ))
    }

public val Res.string.add_client: StringResource by lazy {
      StringResource("string:add_client", "add_client", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 632, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 548, 98),
      ))
    }

public val Res.string.add_employees: StringResource by lazy {
      StringResource("string:add_employees", "add_employees", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 759, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 647, 125),
      ))
    }

public val Res.string.add_file: StringResource by lazy {
      StringResource("string:add_file", "add_file", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 925, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 773, 28),
      ))
    }

public val Res.string.add_job: StringResource by lazy {
      StringResource("string:add_job", "add_job", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 966, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 802, 27),
      ))
    }

public val Res.string.add_more: StringResource by lazy {
      StringResource("string:add_more", "add_more", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1002, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 830, 28),
      ))
    }

public val Res.string.add_new: StringResource by lazy {
      StringResource("string:add_new", "add_new", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1872, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1476, 27),
      ))
    }

public val Res.string.add_new_button: StringResource by lazy {
      StringResource("string:add_new_button", "add_new_button", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1043, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 859, 34),
      ))
    }

public val Res.string.add_new_contact: StringResource by lazy {
      StringResource("string:add_new_contact", "add_new_contact", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1090, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 894, 43),
      ))
    }

public val Res.string.add_new_employee: StringResource by lazy {
      StringResource("string:add_new_employee", "add_new_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1150, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 938, 40),
      ))
    }

public val Res.string.add_new_job: StringResource by lazy {
      StringResource("string:add_new_job", "add_new_job", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1355, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1095, 35),
      ))
    }

public val Res.string.add_new_job_message: StringResource by lazy {
      StringResource("string:add_new_job_message", "add_new_job_message", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1211, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 979, 115),
      ))
    }

public val Res.string.add_new_site: StringResource by lazy {
      StringResource("string:add_new_site", "add_new_site", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1592, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1272, 36),
      ))
    }

public val Res.string.add_new_site_message: StringResource by lazy {
      StringResource("string:add_new_site_message", "add_new_site_message", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1403, 188),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1131, 140),
      ))
    }

public val Res.string.add_new_user_message: StringResource by lazy {
      StringResource("string:add_new_user_message", "add_new_user_message", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1649, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1309, 116),
      ))
    }

public val Res.string.add_new_workspace: StringResource by lazy {
      StringResource("string:add_new_workspace", "add_new_workspace", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1802, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1426, 49),
      ))
    }

public val Res.string.add_note: StringResource by lazy {
      StringResource("string:add_note", "add_note", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2000, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1580, 28),
      ))
    }

public val Res.string.add_note_here: StringResource by lazy {
      StringResource("string:add_note_here", "add_note_here", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1892, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1504, 45),
      ))
    }

public val Res.string.add_notes: StringResource by lazy {
      StringResource("string:add_notes", "add_notes", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1954, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1550, 29),
      ))
    }

public val Res.string.add_site: StringResource by lazy {
      StringResource("string:add_site", "add_site", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2041, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1609, 28),
      ))
    }

public val Res.string.add_step: StringResource by lazy {
      StringResource("string:add_step", "add_step", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2132, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1668, 28),
      ))
    }

public val Res.string.add_steps: StringResource by lazy {
      StringResource("string:add_steps", "add_steps", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2086, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1638, 29),
      ))
    }

public val Res.string.add_team: StringResource by lazy {
      StringResource("string:add_team", "add_team", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2177, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1697, 28),
      ))
    }

public val Res.string.add_your_note_here: StringResource by lazy {
      StringResource("string:add_your_note_here", "add_your_note_here", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2218, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1726, 50),
      ))
    }

public val Res.string.adding_proof: StringResource by lazy {
      StringResource("string:adding_proof", "adding_proof", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2285, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1777, 60),
      ))
    }

public val Res.string.additional_notes: StringResource by lazy {
      StringResource("string:additional_notes", "additional_notes", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2422, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1894, 56),
      ))
    }

public val Res.string.additional_notes_report: StringResource by lazy {
      StringResource("string:additional_notes_report", "additional_notes_report", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2362, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1838, 55),
      ))
    }

public val Res.string.address: StringResource by lazy {
      StringResource("string:address", "address", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2590, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2042, 27),
      ))
    }

public val Res.string.address_mandatory: StringResource by lazy {
      StringResource("string:address_mandatory", "address_mandatory", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2491, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1951, 37),
      ))
    }

public val Res.string.address_required: StringResource by lazy {
      StringResource("string:address_required", "address_required", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2529, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1989, 52),
      ))
    }

public val Res.string.admin: StringResource by lazy {
      StringResource("string:admin", "admin", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2646, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2086, 33),
      ))
    }

public val Res.string.all: StringResource by lazy {
      StringResource("string:all", "all", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2887, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2307, 15),
      ))
    }

public val Res.string.all_contacts: StringResource by lazy {
      StringResource("string:all_contacts", "all_contacts", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2680, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2120, 36),
      ))
    }

public val Res.string.all_employees: StringResource by lazy {
      StringResource("string:all_employees", "all_employees", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2721, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2157, 33),
      ))
    }

public val Res.string.all_rights_reserved: StringResource by lazy {
      StringResource("string:all_rights_reserved", "all_rights_reserved", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2763, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2191, 115),
      ))
    }

public val Res.string.already_have_an_account: StringResource by lazy {
      StringResource("string:already_have_an_account", "already_have_an_account", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2907, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2323, 67),
      ))
    }

public val Res.string.already_have_workspace: StringResource by lazy {
      StringResource("string:already_have_workspace", "already_have_workspace", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2971, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2391, 66),
      ))
    }

public val Res.string.and_we_will: StringResource by lazy {
      StringResource("string:and_we_will", "and_we_will", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3050, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2458, 91),
      ))
    }

public val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3146, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2550, 28),
      ))
    }

public val Res.string.approve: StringResource by lazy {
      StringResource("string:approve", "approve", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3175, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2579, 55),
      ))
    }

public val Res.string.april: StringResource by lazy {
      StringResource("string:april", "april", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3247, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2635, 21),
      ))
    }

public val Res.string.are_you_sure: StringResource by lazy {
      StringResource("string:are_you_sure", "are_you_sure", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3363, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2739, 64),
      ))
    }

public val Res.string.are_you_sure_note: StringResource by lazy {
      StringResource("string:are_you_sure_note", "are_you_sure_note", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3269, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2657, 81),
      ))
    }

public val Res.string.assign_employee: StringResource by lazy {
      StringResource("string:assign_employee", "assign_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3440, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2804, 31),
      ))
    }

public val Res.string.assigned: StringResource by lazy {
      StringResource("string:assigned", "assigned", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3516, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2876, 28),
      ))
    }

public val Res.string.assigned_to: StringResource by lazy {
      StringResource("string:assigned_to", "assigned_to", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3476, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2836, 39),
      ))
    }

public val Res.string.assignees: StringResource by lazy {
      StringResource("string:assignees", "assignees", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3549, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2905, 29),
      ))
    }

public val Res.string.august: StringResource by lazy {
      StringResource("string:august", "august", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3583, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2935, 22),
      ))
    }

public val Res.string.back: StringResource by lazy {
      StringResource("string:back", "back", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3606, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2958, 20),
      ))
    }

public val Res.string.before_you_proceed: StringResource by lazy {
      StringResource("string:before_you_proceed", "before_you_proceed", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3631, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2979, 66),
      ))
    }

public val Res.string.built_for: StringResource by lazy {
      StringResource("string:built_for", "built_for", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3706, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3046, 125),
      ))
    }

public val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3908, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3228, 22),
      ))
    }

public val Res.string.cancel_subscription: StringResource by lazy {
      StringResource("string:cancel_subscription", "cancel_subscription", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3852, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3172, 55),
      ))
    }

public val Res.string.change_or_upgrade_subscription: StringResource by lazy {
      StringResource("string:change_or_upgrade_subscription", "change_or_upgrade_subscription", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3935, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3251, 114),
      ))
    }

public val Res.string.change_plan: StringResource by lazy {
      StringResource("string:change_plan", "change_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4054, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3366, 35),
      ))
    }

public val Res.string.check_soon: StringResource by lazy {
      StringResource("string:check_soon", "check_soon", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4090, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3402, 142),
      ))
    }

public val Res.string.choose_action: StringResource by lazy {
      StringResource("string:choose_action", "choose_action", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4249, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3545, 45),
      ))
    }

public val Res.string.choose_category: StringResource by lazy {
      StringResource("string:choose_category", "choose_category", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4299, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3591, 51),
      ))
    }

public val Res.string.choose_plan: StringResource by lazy {
      StringResource("string:choose_plan", "choose_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4351, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3643, 35),
      ))
    }

public val Res.string.choose_team: StringResource by lazy {
      StringResource("string:choose_team", "choose_team", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4387, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3679, 39),
      ))
    }

public val Res.string.choose_the_plan: StringResource by lazy {
      StringResource("string:choose_the_plan", "choose_the_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4427, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3719, 87),
      ))
    }

public val Res.string.choose_the_right_plan: StringResource by lazy {
      StringResource("string:choose_the_right_plan", "choose_the_right_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4507, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3807, 69),
      ))
    }

public val Res.string.choose_your_workspace: StringResource by lazy {
      StringResource("string:choose_your_workspace", "choose_your_workspace", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4585, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3877, 89),
      ))
    }

public val Res.string.city: StringResource by lazy {
      StringResource("string:city", "city", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4753, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4013, 20),
      ))
    }

public val Res.string.city_required: StringResource by lazy {
      StringResource("string:city_required", "city_required", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4699, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3967, 45),
      ))
    }

public val Res.string.clear: StringResource by lazy {
      StringResource("string:clear", "clear", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4812, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4064, 21),
      ))
    }

public val Res.string.clear_all: StringResource by lazy {
      StringResource("string:clear_all", "clear_all", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4774, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4034, 29),
      ))
    }

public val Res.string.click_here: StringResource by lazy {
      StringResource("string:click_here", "click_here", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4838, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4086, 50),
      ))
    }

public val Res.string.client_feedback: StringResource by lazy {
      StringResource("string:client_feedback", "client_feedback", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4897, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4137, 43),
      ))
    }

public val Res.string.client_signature: StringResource by lazy {
      StringResource("string:client_signature", "client_signature", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4941, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4181, 48),
      ))
    }

public val Res.string.comment: StringResource by lazy {
      StringResource("string:comment", "comment", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4998, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4230, 27),
      ))
    }

public val Res.string.company: StringResource by lazy {
      StringResource("string:company", "company", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5026, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4258, 27),
      ))
    }

public val Res.string.complete_all_tasks_before_submitting_report: StringResource by lazy {
      StringResource("string:complete_all_tasks_before_submitting_report", "complete_all_tasks_before_submitting_report", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5050, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4286, 123),
      ))
    }

public val Res.string.completed: StringResource by lazy {
      StringResource("string:completed", "completed", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5198, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4410, 29),
      ))
    }

public val Res.string.completion_report: StringResource by lazy {
      StringResource("string:completion_report", "completion_report", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5236, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4440, 49),
      ))
    }

public val Res.string.confirm: StringResource by lazy {
      StringResource("string:confirm", "confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5692, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4820, 27),
      ))
    }

public val Res.string.confirm_password: StringResource by lazy {
      StringResource("string:confirm_password", "confirm_password", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5537, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4677, 48),
      ))
    }

public val Res.string.confirm_password_reset: StringResource by lazy {
      StringResource("string:confirm_password_reset", "confirm_password_reset", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5286, 250),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4490, 186),
      ))
    }

public val Res.string.confirm_registration: StringResource by lazy {
      StringResource("string:confirm_registration", "confirm_registration", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5590, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4726, 56),
      ))
    }

public val Res.string.confirmation: StringResource by lazy {
      StringResource("string:confirmation", "confirmation", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5655, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4783, 36),
      ))
    }

public val Res.string.contact: StringResource by lazy {
      StringResource("string:contact", "contact", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6862, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5942, 27),
      ))
    }

public val Res.string.contact_added: StringResource by lazy {
      StringResource("string:contact_added", "contact_added", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5803, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4919, 57),
      ))
    }

public val Res.string.contact_added_successfully: StringResource by lazy {
      StringResource("string:contact_added_successfully", "contact_added_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5724, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4848, 70),
      ))
    }

public val Res.string.contact_and_site_details: StringResource by lazy {
      StringResource("string:contact_and_site_details", "contact_and_site_details", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5869, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4977, 64),
      ))
    }

public val Res.string.contact_deleted: StringResource by lazy {
      StringResource("string:contact_deleted", "contact_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5942, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5042, 63),
      ))
    }

public val Res.string.contact_deteils: StringResource by lazy {
      StringResource("string:contact_deteils", "contact_deteils", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6006, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5106, 43),
      ))
    }

public val Res.string.contact_information: StringResource by lazy {
      StringResource("string:contact_information", "contact_information", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6050, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5150, 55),
      ))
    }

public val Res.string.contact_name: StringResource by lazy {
      StringResource("string:contact_name", "contact_name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6281, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5381, 36),
      ))
    }

public val Res.string.contact_name_and_type: StringResource by lazy {
      StringResource("string:contact_name_and_type", "contact_name_and_type", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6106, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5206, 57),
      ))
    }

public val Res.string.contact_name_mandatory: StringResource by lazy {
      StringResource("string:contact_name_mandatory", "contact_name_mandatory", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6160, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5264, 50),
      ))
    }

public val Res.string.contact_name_required: StringResource by lazy {
      StringResource("string:contact_name_required", "contact_name_required", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6211, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5315, 65),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("about", Res.string.about)
  map.put("about_contact", Res.string.about_contact)
  map.put("about_job", Res.string.about_job)
  map.put("about_site", Res.string.about_site)
  map.put("about_this_contact", Res.string.about_this_contact)
  map.put("access_dashboard", Res.string.access_dashboard)
  map.put("access_the_platform", Res.string.access_the_platform)
  map.put("active", Res.string.active)
  map.put("add", Res.string.add)
  map.put("add_a_contact", Res.string.add_a_contact)
  map.put("add_client", Res.string.add_client)
  map.put("add_employees", Res.string.add_employees)
  map.put("add_file", Res.string.add_file)
  map.put("add_job", Res.string.add_job)
  map.put("add_more", Res.string.add_more)
  map.put("add_new", Res.string.add_new)
  map.put("add_new_button", Res.string.add_new_button)
  map.put("add_new_contact", Res.string.add_new_contact)
  map.put("add_new_employee", Res.string.add_new_employee)
  map.put("add_new_job", Res.string.add_new_job)
  map.put("add_new_job_message", Res.string.add_new_job_message)
  map.put("add_new_site", Res.string.add_new_site)
  map.put("add_new_site_message", Res.string.add_new_site_message)
  map.put("add_new_user_message", Res.string.add_new_user_message)
  map.put("add_new_workspace", Res.string.add_new_workspace)
  map.put("add_note", Res.string.add_note)
  map.put("add_note_here", Res.string.add_note_here)
  map.put("add_notes", Res.string.add_notes)
  map.put("add_site", Res.string.add_site)
  map.put("add_step", Res.string.add_step)
  map.put("add_steps", Res.string.add_steps)
  map.put("add_team", Res.string.add_team)
  map.put("add_your_note_here", Res.string.add_your_note_here)
  map.put("adding_proof", Res.string.adding_proof)
  map.put("additional_notes", Res.string.additional_notes)
  map.put("additional_notes_report", Res.string.additional_notes_report)
  map.put("address", Res.string.address)
  map.put("address_mandatory", Res.string.address_mandatory)
  map.put("address_required", Res.string.address_required)
  map.put("admin", Res.string.admin)
  map.put("all", Res.string.all)
  map.put("all_contacts", Res.string.all_contacts)
  map.put("all_employees", Res.string.all_employees)
  map.put("all_rights_reserved", Res.string.all_rights_reserved)
  map.put("already_have_an_account", Res.string.already_have_an_account)
  map.put("already_have_workspace", Res.string.already_have_workspace)
  map.put("and_we_will", Res.string.and_we_will)
  map.put("app_name", Res.string.app_name)
  map.put("approve", Res.string.approve)
  map.put("april", Res.string.april)
  map.put("are_you_sure", Res.string.are_you_sure)
  map.put("are_you_sure_note", Res.string.are_you_sure_note)
  map.put("assign_employee", Res.string.assign_employee)
  map.put("assigned", Res.string.assigned)
  map.put("assigned_to", Res.string.assigned_to)
  map.put("assignees", Res.string.assignees)
  map.put("august", Res.string.august)
  map.put("back", Res.string.back)
  map.put("before_you_proceed", Res.string.before_you_proceed)
  map.put("built_for", Res.string.built_for)
  map.put("cancel", Res.string.cancel)
  map.put("cancel_subscription", Res.string.cancel_subscription)
  map.put("change_or_upgrade_subscription", Res.string.change_or_upgrade_subscription)
  map.put("change_plan", Res.string.change_plan)
  map.put("check_soon", Res.string.check_soon)
  map.put("choose_action", Res.string.choose_action)
  map.put("choose_category", Res.string.choose_category)
  map.put("choose_plan", Res.string.choose_plan)
  map.put("choose_team", Res.string.choose_team)
  map.put("choose_the_plan", Res.string.choose_the_plan)
  map.put("choose_the_right_plan", Res.string.choose_the_right_plan)
  map.put("choose_your_workspace", Res.string.choose_your_workspace)
  map.put("city", Res.string.city)
  map.put("city_required", Res.string.city_required)
  map.put("clear", Res.string.clear)
  map.put("clear_all", Res.string.clear_all)
  map.put("click_here", Res.string.click_here)
  map.put("client_feedback", Res.string.client_feedback)
  map.put("client_signature", Res.string.client_signature)
  map.put("comment", Res.string.comment)
  map.put("company", Res.string.company)
  map.put("complete_all_tasks_before_submitting_report", Res.string.complete_all_tasks_before_submitting_report)
  map.put("completed", Res.string.completed)
  map.put("completion_report", Res.string.completion_report)
  map.put("confirm", Res.string.confirm)
  map.put("confirm_password", Res.string.confirm_password)
  map.put("confirm_password_reset", Res.string.confirm_password_reset)
  map.put("confirm_registration", Res.string.confirm_registration)
  map.put("confirmation", Res.string.confirmation)
  map.put("contact", Res.string.contact)
  map.put("contact_added", Res.string.contact_added)
  map.put("contact_added_successfully", Res.string.contact_added_successfully)
  map.put("contact_and_site_details", Res.string.contact_and_site_details)
  map.put("contact_deleted", Res.string.contact_deleted)
  map.put("contact_deteils", Res.string.contact_deteils)
  map.put("contact_information", Res.string.contact_information)
  map.put("contact_name", Res.string.contact_name)
  map.put("contact_name_and_type", Res.string.contact_name_and_type)
  map.put("contact_name_mandatory", Res.string.contact_name_mandatory)
  map.put("contact_name_required", Res.string.contact_name_required)
}
